import script from "./ViewQuizRecordModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ViewQuizRecordModal.vue?vue&type=script&setup=true&lang=ts"

import "./ViewQuizRecordModal.vue?vue&type=style&index=0&id=f4120f82&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f4120f82"]])

export default __exports__